import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class Purchase {

  eventCode = 'n:ph';

  setEventObject(coupon: string, discount: number, paymentMethod: string, shippingCost: number, subTotal: number, itemCount: number, grandTotal: number) {

    let eventObject = {
      code: this.eventCode,
      ek: coupon,
      el: discount,
      em: paymentMethod,
      ep: shippingCost,
      er: subTotal,
      ec: itemCount,
      es: grandTotal,
      items: []
    };

    return eventObject;
  }

}


